export const categories = [
   {
      name: 'Baby',
      value: 'baby',
      link: 'baby',
      img: '015-baby.png'
   },
   {
      name: 'Beauty',
      value: 'beauty',
      link: 'beauty',
      img: '002-makeover.png'
   },
   {
      name: 'Clothing',
      value: 'clothing',
      link: 'clothing',
      img: '003-coat.png'
   },
   {
      name: 'Computer',
      value: 'computer',
      link: 'computer',
      img: '004-student.png'
   },
   {
      name: 'Electronics',
      value: 'electronics',
      link: 'electronics',
      img: '005-indoor-antenna.png'
   },
   {
      name: 'Fitness',
      value: 'fitness',
      link: 'fitness',
      img: '006-athlete.png'
   },
   {
      name: 'Furniture',
      value: 'furniture',
      link: 'furniture',
      img: '007-armchair.png'
   },
   {
      name: 'Health',
      value: 'health',
      link: 'health',
      img: '008-healthy.png'
   },
   {
      name: 'Home Accessories',
      value: 'home_accessories',
      link: 'homeaccessories',
      img: '009-house.png'
   },
   {
      name: 'Jewelry',
      value: 'jewelry',
      link: 'jewelry',
      img: '010-necklace.png'
   },
   {
      name: 'Office',
      value: 'office',
      link: 'office',
      img: '011-attached.png'
   },
   {
      name: 'Outdoor',
      value: 'outdoor',
      link: 'outdoor',
      img: '012-tent.png'
   },
   {
      name: 'Tools',
      value: 'tools',
      link: 'tools',
      img: '013-measuring-tape.png'
   },
   {
      name: 'Toys',
      value: 'toys',
      link: 'toys',
      img: '014-robot.png'
   },
   {
      name: 'Other',
      value: 'other',
      link: 'other',
      img: '016-question.png'
   }
];
